/* eslint-disable prettier/prettier */
import React, { FC, Key, PropsWithChildren } from "react"
import { CSSTransition, SwitchTransition } from "react-transition-group"

import styles from "./index.module.less"

export const CommonTransition: FC<
    { state: Key; horiz?: boolean; reverse?: boolean } & PropsWithChildren
> = ({ state, horiz, reverse, children }) => {
    return (
        <SwitchTransition>
            <CSSTransition
                key={state}
                addEndListener={(node, done) =>
                    node.addEventListener("transitionend", done, false)
                }
                classNames={
                    horiz
                        ? {
                              enter: !reverse
                                  ? styles.commonHrzEnter
                                  : styles.commonHrzEnterReverse,
                              enterActive: !reverse
                                  ? styles.commonHrzEnterActive
                                  : styles.commonHrzEnterActiveReverse,
                              exit: !reverse
                                  ? styles.commonHrzExit
                                  : styles.commonHrzExitReverse,
                              exitActive: !reverse
                                  ? styles.commonHrzExitActive
                                  : styles.commonHrzExitActiveReverse,
                          }
                        : {
                              enter: !reverse
                                  ? styles.commonEnter
                                  : styles.commonEnterReverse,
                              enterActive: !reverse
                                  ? styles.commonEnterActive
                                  : styles.commonEnterActiveReverse,
                              exit: !reverse
                                  ? styles.commonExit
                                  : styles.commonExitReverse,
                              exitActive: !reverse
                                  ? styles.commonExitActive
                                  : styles.commonExitActiveReverse,
                          }
                }
                unmountOnExit
            >
                {children}
            </CSSTransition>
        </SwitchTransition>
    )
}
